import { getTicketTypeById } from '../../../sales-data/selectors/tickets/get-ticket-type-by-id';
import { getTicketTypeTicketCount } from '../../../sales-data/utils/tickets/ticket-type-utils';
import { getRemainingOrderTicketCountForAreaCategory } from '../../selectors/tickets/get-remaining-order-ticket-count-for-area-category';
export const canTicketBeAddedToOrder = (showtimeId, ticketTypeId, quantity) => {
    const ticketType = getTicketTypeById(ticketTypeId);
    const { areaCategoryId } = ticketType;
    const ticketCount = getTicketTypeTicketCount(ticketType);
    const remainingTicketCount = getRemainingOrderTicketCountForAreaCategory(showtimeId, areaCategoryId);
    return remainingTicketCount >= ticketCount * quantity;
};
